// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xFUS","question":"styles_question__1rHZh","description":"styles_description__1tC4N"};